/* eslint eqeqeq: 0 */
/*
import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import { getUnderAge, setUnderAge } from "../utils/underAge";
import styled from "styled-components";
import underAge from "../assets/under-image-check.png";
import Image from "gatsby-image";

import Layout from "../components/Layout";
import CallToAction from "../components/CallToAction/CallToAction";
import Producers from "../components/Producers/Producers";
import Dialog from '@material-ui/core/Dialog';
import CustomCarousel from "../components/CustomCarousel/CustomCarousel";

import SEO from '../components/Seo';

// Inner Components
const Button = styled.button`
  border: 2px solid #B89976;
  border-radius: 3px;
  color: ${props => props.main ? 'white' : '#B89976'};
  background-color: ${props => props.main ? '#B89976' : 'white'};
  font-weight: bold;
  padding: 8px 35px;
  text-transform: uppercase;
  margin-left: ${props => props.marginLeft ? props.marginLeft : null};
  margin-right: ${props => props.marginRight ? props.marginRight : null};
  @media (max-width: 768px) {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    width: 100%;
  }
`;

const P = styled.p`
  font-size: 15px;
  color: ${props => props.color ? props.color : null};
  text-align: ${props => props.center ? 'center' : 'left'};
`;

const ModalTitle = styled.h2`
  font-size: 36px;
  text-transform: uppercase;
  font-weight: bold;
  color: #B89976;
  @media (max-width: 768px) {
    font-size: 26px;
    text-align: center;
  }
`;

const MobileHidden = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

const ShowMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MaintenanceContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 0 25%;
  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

// Index Components
const IndexPage = ({
  data: {
    allStrapiHomepage: { nodes: homepage },
    allStrapiProducers: { nodes: producers }
  }
}) => {

  // Data from query page
  const { callToAction, firstSlide, secondSlide, thirdSlide, maintenance, maintenanceImage } = homepage[0];

  // States
  const [dialogOpen, setDialogOpen] = useState(!maintenance);
  const [checkStorage, setCheckStorage] = useState(false);
  const [underAgeClient, setUnderAgeClient] = useState(null);

  // Check under age condition
  useEffect(() => {  
    const underAgeStorage = getUnderAge();
    setCheckStorage(true);

    if (!underAgeStorage && (underAgeStorage == false)) {
      handleDialogClose();
    }
  }, []);

  useEffect(() => {
    if (maintenance) {
      document.body.style.overflow = 'hidden';
      return;
    }
  }, [maintenance]);

  const underAgeHandler = (value) => {
    if (!maintenance) {
      setUnderAgeClient(value);
      setUnderAge(value);

      if (!value) {
        handleDialogClose();
      }
    }
  }

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  let filteredProducers = [];

  producers.forEach(producer => {
    if (producer.products.length > 0) {
      filteredProducers.push(producer);
    }
  });

  return (
    <Layout>
      <SEO 
        pageTitle={'Loja Online'}
        description={'Página oficial da Feira do Vinho do Dão - programa, imagens e noticias ao momento'}
      />
      {maintenance &&
        <MaintenanceContainer>
          <Image style={{width: '100%', height: 'auto'}} fluid={maintenanceImage.childImageSharp.fluid} />
        </MaintenanceContainer>
      }
      <CustomCarousel
        firstSlide={firstSlide}
        secondSlide={secondSlide}
        thirdSlide={thirdSlide}
      />
      <MobileHidden>
        <CallToAction
          title={callToAction.title}
          subtitle={callToAction.subtitle}
          buttonTitle={callToAction.buttonTitle}
          buttonUrl={callToAction.buttonUrl}
        />
      </MobileHidden>
      <Producers id="store" name="store" producers={filteredProducers} />
      <MobileHidden>
        <Dialog
          open={dialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <div style={{ margin: '15px 40px' }}>
            {!underAgeClient ? (
              <div style={{ margin: '20px 0px' }}>
                <P color="#B89976" center>Bem vindo à Loja de Vinhos da Feira do Vinho do Dão</P>
                <ModalTitle>CONFIRMAÇÃO DE IDADE</ModalTitle>
                <div style={{ margin: '25px 0px' }}>
                  <P color="#757575" center>Tem idade legal para consumo de bebidas alcoólicas?</P>
                </div>
                <ButtonsContainer>
                  <Button main marginRight="10px" onClick={underAgeHandler.bind(this, false)}>Sim</Button>
                  <Button marginLeft="10px" onClick={underAgeHandler.bind(this, true)}>Não</Button>
                </ButtonsContainer>
              </div>
            ) : (
                <div style={{ margin: '15px 0px' }}>
                  <P color="#B89976" center>Infelizmente o acesso é restrito!</P>
                  <ModalTitle>Obrigado pela sua visita</ModalTitle>
                  <P color="#757575" center>Aguardamos por si no futuro</P>
                </div>
              )}
          </div>
        </Dialog>
      </MobileHidden>
      {(dialogOpen && checkStorage) &&
        <ShowMobile>
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: '#AB8356',
            zIndex: '100',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
          }}>
            <img
              src={underAge}
              alt="background-under"
              style={{ height: '100%', width: '100%' }}
            />
          </div>
        </ShowMobile>
      }
    </Layout>
  );
};

export const query = graphql`
  {
    allStrapiHomepage {
      nodes {
        maintenance
        maintenanceImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        callToAction {
          title
          subtitle
          buttonTitle
          buttonUrl
        }
        firstSlide {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        secondSlide {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        thirdSlide {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    allStrapiProducers(filter: {mapOnly: {eq: false}}) {
      nodes {
        id
        name
        slug
        logo {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        products {
          id
        }
      }
    }
  }
`;

export default IndexPage;
*/

import React from "react";
import styled from "styled-components";
import backLink from "../images/fvd-maintenance.png"

const Background = styled.div`
  background-image: url(${backLink});
  background-size: cover;
  background-position: top;
  min-height: 100%;
  height: 100vh;
  position: relative;
`;

const IndexPage = () => {
  return (
    <Background />
  );
}

export default IndexPage;